








































import { Component, Inject, InjectReactive, Vue } from 'vue-property-decorator';

import { OrdwayService } from '@/services/ordway-service';
import { FeedProduct } from '../../../models';

import InformationRow from '@/components/display/information-row.vue';
import ProductBillingDisplay from '@/components/display/product-billing-display.vue';
import ChangeProductOrgModal from '@/pages/account/products/ChangeProductOrgModal.vue';
import Toast from '@/components/display/toast.vue';
import AddNote from '@/components/add business objects/addNote.vue';
import FeedProductName from './components/FeedProductName.vue';
import FeedProductSite from './components/FeedProductSite.vue';
import ProductCountryFlagRow from '@/components/display/product-country-flag-row.vue';
import { ProductStatusService } from '@/services/product-status-service';
import FaultStatusRow from '@/components/display/information-rows/fault-status-row.vue';
import OrgRow from '@/components/display/information-rows/org-row.vue';
import { ProductOrderStatusEnum, ProductStatus } from '@/api';
import { formattedStatus } from '@/common/StatusUtil';

@Component({
	computed: {
		ProductOrderStatusEnum() {
			return ProductOrderStatusEnum;
		},
		ProductStatus() {
			return ProductStatus;
		},
	},
	components: {
		OrgRow,
		FaultStatusRow,
		InformationRow,
		ProductBillingDisplay,
		ChangeProductOrgModal,
		FeedProductName,
		FeedProductSite,
		AddNote,
		ProductCountryFlagRow,
	},
})
export default class FeedProductInformation extends Vue {
	@InjectReactive('feedProduct')
	public feedProduct!: FeedProduct;

	@Inject('refreshFeedProduct')
	private refreshFeedProduct!: () => Promise<void>;

	public canChangeProductOrg: boolean | null = null;

	public get formattedProductStatus(): string {
		return formattedStatus(
			this.feedProduct,
			ProductStatusService.formatProductStatus(
				this.feedProduct?.status ?? null,
				this.feedProduct?.termsState ?? null,
			),
			'product',
		);
	}

	private toast: Toast = new Toast();
	private readonly PRODUCT_ORG_CHANGE_MODAL_ID = 'product-org-change-modal';

	public async created(): Promise<void> {
		this.canChangeProductOrg = await OrdwayService.canChangeProductOrg(this.feedProduct);
	}

	public async onOrgChanged(): Promise<void> {
		await this.refreshFeedProduct();
		this.$bvModal.hide(this.PRODUCT_ORG_CHANGE_MODAL_ID);
		this.toast.makeToast('Org changed successfully', 'Success', 'success');
	}

	public async resetProductOrg(): Promise<void> {
		await this.refreshFeedProduct();
	}

	public openProductOrgChangeModal(): void {
		this.$bvModal.show(this.PRODUCT_ORG_CHANGE_MODAL_ID);
	}
}
